/**
 * Yeni sürüm yayına girince açık sekme eski sürümün sayfa dosyalarını ister ve bulamaz
 * ("Failed to fetch dynamically imported module"). Böyle bir hatada sayfa bir kez
 * yenilenir; yenileme yeni sürümü yükler. Döngüye girmemek için 30 saniyede en fazla bir kez.
 */
const KEY = "theadam:chunk-reload";

export const isChunkError = (err: unknown) => /dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/i.test(String((err as Error | undefined)?.message ?? err));

/** Yenileme yapıldıysa true. */
export function reloadOnce(): boolean {
  try {
    const last = Number(sessionStorage.getItem(KEY) ?? 0);
    if (Date.now() - last < 30_000) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    // Depolama kapalıysa yine de bir kez dener.
  }
  window.location.reload();
  return true;
}
